import { render, staticRenderFns } from "./ViewRegistration.vue?vue&type=template&id=4578a718&scoped=true&"
import script from "./ViewRegistration.vue?vue&type=script&lang=ts&"
export * from "./ViewRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./ViewRegistration.vue?vue&type=style&index=0&id=4578a718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4578a718",
  null
  
)

export default component.exports